import keycloakStore from "@/businesslogic/stores/keycloakStore";
import axios from "axios";
import Logger from "js-logger";
import { Anfrage } from "@/model/Anfrage";

class SanierungsService {
  http() {
    const keycloakAccessToken = keycloakStore().getKeycloakAccessToken();

    let headers;
    if (keycloakAccessToken) {
      headers = {
        Authorization: "Bearer " + keycloakAccessToken,
        "Content-Type": "application/json",
      };
    }

    return axios.create({
      baseURL: process.env.VUE_APP_BACKEND_URL,
      timeout: process.env.VUE_APP_BACKEND_TIMEOUT,
      headers: headers,
    });
  }

  getBaseUrl(isMakler: boolean) {
    if (!isMakler) {
      return "/api/direkt/";
    } else {
      return "/api/makler/";
    }
  }

  kernsanierungPruefen(anfrage: Anfrage, versicherungsbeginn: string) {
    return this.http()
      .post(this.getBaseUrl(anfrage.isMakler) + "sanierung/checkKernsanierung", {
        sanierungsdaten: anfrage.gebaeudedaten.sanierungsdaten,
        versicherungsbeginn: versicherungsbeginn,
        baujahr: anfrage.gebaeudedaten.baujahr,
      })
      .then((antwort: any) => {
        Logger.debug("Antwort Kernsanierung:", antwort);
        return antwort;
      })
      .catch((fehler) => {
        Logger.debug("Prüfung auf Kernsanierung schlug fehl:", fehler);
      });
  }

  kernsanierungsjahrErmitteln(anfrage: Anfrage) {
    return this.http()
      .post(this.getBaseUrl(anfrage.isMakler) + "sanierung/ermittelKernsanierungsjahr", {
        sanierungsdaten: anfrage.gebaeudedaten.sanierungsdaten,
      })
      .then((antwort: any) => {
        Logger.debug("Antwort Jahr der Kernsanierung:", antwort);
        return antwort;
      })
      .catch((fehler) => {
        Logger.debug("Die Ermittlung des Kernsanierungjahres schlug fehl:", fehler);
      });
  }
}

export default new SanierungsService();
